import React from 'react'
import { Navigate } from 'react-router-dom'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import { logoutHandler } from 'src/consumer/services/loginLogoutHandlers'

// Gates the entire /ipd-home/* tree (docs/INPATIENT_MANAGEMENT_PLAN.md §8.1).
// 1. Auth check — token + authorities present (patient-portal guard pattern).
// 2. Role check — any of the four IPD ward-staff roles.
//
// No 2FA gate in v1 (explicit plan decision). Location scoping (which clinic
// locations this staffer may act on) is NOT a route concern — it lives in
// IpdContext, fed by GET /api/secure/ipd/my-scope.

export default function IpdPortalProtectedRoute({ children }) {
  const token = localStorage.getItem('token')
  const authorities = localStorage.getItem('authorities')

  if (isTokenInvalidOrAbsent(token) || !authorities) {
    logoutHandler()
    return <Navigate to="/login" replace />
  }

  const { isIpdManager, isIpdFrontDesk, isIpdNurse, isIpdStaff } = getAllRolesInBoolean() || {}
  if (!isIpdManager && !isIpdFrontDesk && !isIpdNurse && !isIpdStaff) {
    return <Navigate to="/" replace />
  }

  return children
}
